module.exports = __webpack_public_path__ + "static/media/annandale-casks.0b9b5f8e.jpg";